import styled from "styled-components";

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px;
`;

export const InfoRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  border: 1px solid ${(props) => props.theme.application.border};
  padding: 10px;
  border-radius: 4px;
  gap: 20px;
  margin-bottom: 10px;
`;

export const InfoField = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: capitalize;
  cursor: pointer;
`;
export const BoldInfoField = styled(InfoField)`
  font-weight: bold;
  text-transform: capitalize;
`;

export const FieldWrapper = styled.div`
  display: flex;
 margin-left:10px;
`;

export const TextInputWrapper = styled.div`
  flex: 1;
  margin-right: 10px;

  &:last-child {
    margin-right: 0;
  }
`;
export const ButtonWrapper = styled.div`
  display: flex;
  justify-content:  center;
`;